import { awsApiInstance } from '../api/aws-api';
import axios, { AxiosError } from 'axios';
import { showToast } from '../components/toasts';
import useAuth from '../hooks/auth-hooks';

import { INewPartner, IPostPartnerResponse } from '../models/partner.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts a new Partner
 * 
 * @param {INewPartner} partner the partner form data
 * 
 * @returns {IPostPartnerResponse} the api response | error
 */
const PostPartnerNew = async (partner: INewPartner): Promise<IPostPartnerResponse> => {
  try {
    const { userId } = useAuth()!; 

    const modelData = {
      wpID: userId,
      partnerName: partner.partnerName,
      accountNum: partner.accountNumber,
      exportTo: partner.exportTo,
      fileType: partner.exportFileType
    };

    const { data } = await awsApiInstance.post('/partners', modelData );

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error post new partner');
    throw(error);
  }
} 

export default PostPartnerNew;